import React from 'react';

const STATUS_STYLES = {
  // Proposal statuses
  draft: 'bg-gray-100 text-gray-700',
  pending_qa: 'bg-yellow-100 text-yellow-700',
  approved: 'bg-green-100 text-green-700',
  sent_to_client: 'bg-blue-100 text-blue-700',
  accepted: 'bg-emerald-100 text-emerald-700',
  rejected: 'bg-red-100 text-red-700',
  sent_back: 'bg-orange-100 text-orange-700',
  client_rejected: 'bg-orange-100 text-orange-700',
  expired: 'bg-gray-100 text-gray-500',
  // Decision Engine results
  proceed: 'bg-green-100 text-green-700',
  conditional: 'bg-yellow-100 text-yellow-700',
  reject: 'bg-red-100 text-red-700',
  // Worker verdicts
  greenlight: 'bg-green-100 text-green-700',
  // Generation statuses
  queued: 'bg-gray-100 text-gray-600',
  workers_running: 'bg-blue-100 text-blue-700',
  generating_proposal: 'bg-primary-100 text-primary-700',
  completed: 'bg-green-100 text-green-700',
  failed: 'bg-red-100 text-red-700',
  running: 'bg-blue-100 text-blue-700',
  // Check results
  pass: 'bg-green-100 text-green-700',
  fail: 'bg-red-100 text-red-700',
  // QA
  approved_qa: 'bg-green-100 text-green-700',
  rejected_qa: 'bg-red-100 text-red-700',
  // Human decisions
  decline: 'bg-red-100 text-red-700',
  schedule_follow_up: 'bg-orange-100 text-orange-700',
};

const STATUS_LABELS = {
  pending_qa: 'Under Review',
  sent_back: 'Sent Back',
  client_rejected: 'Client Feedback',
  sent_to_client: 'Sent to Client',
  workers_running: 'Workers Running',
  generating_proposal: 'Generating',
  greenlight: 'Green Light',
  regulatory_structuring: 'Regulatory & Structuring',
  schedule_follow_up: 'Schedule Follow-up',
};

const ProposalStatusBadge = ({ status, size = 'sm' }) => {
  if (!status) return null;

  const key = status.toLowerCase().replace(/\s+/g, '_');
  const style = STATUS_STYLES[key] || 'bg-gray-100 text-gray-600';
  const label = STATUS_LABELS[key] || status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

  const sizeClass = size === 'sm'
    ? 'px-2 py-0.5 text-xs'
    : size === 'md'
    ? 'px-3 py-1 text-sm'
    : 'px-4 py-1.5 text-base';

  return (
    <span className={`inline-flex items-center font-medium rounded-full ${style} ${sizeClass}`}>
      {label}
    </span>
  );
};

export default ProposalStatusBadge;
